module.exports = __webpack_public_path__ + "media/customizations/regencyathollysprings/back-67420a7b3c3b4ec6fad45463bd6569e7.jpg";